import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { Button, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Editor } from '@tinymce/tinymce-react';
import { imageUploadHandler } from 'utils/tools';
import {
  forceFeedback,
  getByIdOrders,
  getOrderHistory,
} from 'redux/orders/actions';
import GridPhotos from 'components/common/GridPhotos';
import { getOrderHistoriesSelectors } from 'redux/orders/selectors';
import OrderCancel from 'assets/images/order_cancel.png';

const CancelStatus = ({ onCancel, order, item }) => {
  const dispatch = useDispatch();
  const [note, setNote] = useState('');
  const [isReject, setReject] = useState(false);
  const orderHistories = useSelector(getOrderHistoriesSelectors);
  const isLast = orderHistories[orderHistories.length - 1]?.id === item?.id;

  const reject = () => {
    setReject(true);
  };

  const confirmReject = useCallback(() => {
    dispatch(
      forceFeedback({
        id: item.id,
        data: {
          feedback: note,
        },
      }),
    ).then(({ payload }) => {
      console.log('payload', payload);
      if (payload?.id) {
        dispatch(getOrderHistory(order?.backupId));
        dispatch(getByIdOrders({ data: order }));
        onCancel();
        setNote('');
      }
    });
    // eslint-disable-next-line
  }, [item, note]);

  if (isReject) {
    return (
      <div>
        {isLast && (
          <Typography.Title level={3}>
            {i18next.t(`orders.rejectOrderStatus.${item.status}`)}
          </Typography.Title>
        )}
        <div
          className="html-content"
          dangerouslySetInnerHTML={{ __html: item.note }}
        />
        <GridPhotos images={order?.products?.[0]?.productImages || []} />
        <br />
        <Editor
          // bounds=".app"
          // modules={modules}
          toolbar="undo redo | forecolor backcolor | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | link media image"
          init={{
            height: '400',
            images_upload_handler: imageUploadHandler,
          }}
          plugins="code link checklist autolink image imagetools media"
          onEditorChange={(text) => {
            setNote(text);
          }}
        />
        <br />
        <br />
        {isLast ? (
          <div>
            <Button onClick={confirmReject} type="primary">
              {i18next.t('button.reOpen')}
            </Button>
            &nbsp;&nbsp;
            <Button onClick={() => setReject(false)}>
              {i18next.t('button.cancel')}
            </Button>
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <div>
      {isLast && (
        <Typography.Title level={3}>
          {i18next.t(`orders.orderStatus.${item.status}`)}
        </Typography.Title>
      )}
      <div
        className="html-content"
        dangerouslySetInnerHTML={{ __html: item.note }}
      />
      <GridPhotos images={order?.products?.[0]?.productImages || []} />
      {!order?.products?.[0]?.productImages?.length && (
        <img className="orderStatusImage" src={OrderCancel} alt="" />
      )}
      <br />
      {isLast ? (
        <Button type="primary" onClick={reject}>
          {i18next.t('button.reOpen')}
        </Button>
      ) : null}
    </div>
  );
};

CancelStatus.propTypes = {
  order: PropTypes.object,
  item: PropTypes.object,
  onCancel: PropTypes.func,
};

export default CancelStatus;
